
export class Puesto {
    puestoid: number = 0;
    nombre: string = "";
    departamentoid: number = 0;
    puestosuperiorid: number = 0;
    activo: boolean = true;
    esdocente: boolean = false;
    otropuesto:boolean = false;
    gradosid: any;
    materiasid: any;
    nivelid: number = 0;

    constructor(init?: Partial<Puesto>) {
        Object.assign(this, init);
    }
}
